export default "__VITE_ASSET__Ca1Y_9hS__"